<template lang="html">
  <div class="progress-bubbles">
    <div v-for="bubble in total" class="bubble" :class="{active: current === bubble}" :key="bubble" @click="$emit('click', bubble)"></div>
  </div>
</template>

<script>
export default {
  props: {
    current: Number,
    total: {
      type: Number,
      default: 2,
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '../styles/colors'

.progress-bubbles
  opacity: 0.7
  text-align: center
  height: 12px
  line-height: 12px

  .bubble
    background-color: $text
    width: 12px
    height: @width
    border-radius: (@width / 2)px
    position: relative
    display: inline-block

    &:not(:last-child)
      margin-right: 8px

    &:after
      position: absolute
      top: 2px
      left: 2px
      width: 8px
      height: @width
      border-radius: (@width / 2)px
      content: ''
      background-color: $default-dark
      transition: transform 200ms ease

    &.active:after
      transform: scale(0)
</style>
